module.exports = __webpack_public_path__ + "img/unsplash.a81b99cf.jpg";